import { getLocalStorageItem } from './LocalStorage';

/**
 * Extracts the first subdomain from the REACT_APP_API_URL environment variable.
 * @returns {string | null} The first subdomain if present, otherwise null.
 */
// const getFirstSubdomain = (): string | null => {
//   const storageDomain = getLocalStorageItem('domain');
//   if (storageDomain) {
//     return storageDomain;
//   }

//   try {
//     const { hostname } = window.location;
//     // const { hostname } = window.location;

//     const parts = hostname.split('.');

//     // Handle cases like localhost or single part domains
//     if (parts.length < 2 || (parts.length === 2 && parts[1] === 'localhost')) {
//       return '';
//     }

//     // Return first part as subdomain
//     return parts[0];
//   } catch {
//     return '';
//   }
// };

/**
 * Extracts the first subdomain from the REACT_APP_API_URL environment variable.
 * @returns {string | null} The first subdomain if present, otherwise null.
 */
const getFirstSubdomain = (): string | null => {
  try {
    // ✅ 1. Check URL query param
    const parameters = new URLSearchParams(window.location.search);
    const domainFromUrl = parameters.get('domain');

    if (domainFromUrl) {
      localStorage.setItem('domain', domainFromUrl); // optional cache
      return domainFromUrl;
    }

    // ✅ 2. Check localStorage
    const storageDomain = getLocalStorageItem('domain');
    if (storageDomain) {
      return storageDomain;
    }

    // ✅ 3. Extract from hostname
    const { hostname } = window.location;
    const parts = hostname.split('.');

    if (parts.length < 2 || (parts.length === 2 && parts[1] === 'localhost')) {
      return '';
    }

    // 👉 handle runa-test → runa, but keep saqr-tech
    let subdomain = parts[0];

    if (subdomain.endsWith('-test')) {
      subdomain = subdomain.slice(0, -5);
    } else if (subdomain.endsWith('-dev')) {
      subdomain = subdomain.slice(0, -4);
    }

    return subdomain;
  } catch {
    return '';
  }
};

/**
 * Returns a valid domain for branding/headers, or null if it's blocked/empty.
 * @returns {string | null}
 */
export const getValidDomain = (): string | null => {
  const domain = getFirstSubdomain() || '';
  const blocked = ['web-dev', 'web-test', 'web', 'localhost'];

  if (domain && !blocked.some((d) => domain.includes(d))) {
    return domain;
  }
  return null;
};

export default getFirstSubdomain;
